
    import { EarleyParser, createEnglishGrammar, createBuffaloLexicon, renderTreeToSVG, interpretTreeHTML } from './src/index.js';

    const grammar = createEnglishGrammar();
    const lexicon = createBuffaloLexicon();
    const parser = new EarleyParser(grammar, lexicon);

    window.words = [];
    window.parseTrees = [];
    window.currentParse = 0;
    window.currentMode = 'grammar'; // 'grammar' or 'wild'

    window.setMode = function(mode) {
      currentMode = mode;
      const grammarBtn = document.getElementById('grammar-mode-btn');
      const wildBtn = document.getElementById('wild-mode-btn');
      const description = document.getElementById('mode-description');
      const wildBuffaloBtn = document.getElementById('wild-btn');
      const bisonBtn = document.getElementById('bison-btn');
      const buttonsContainer = document.getElementById('buffalo-buttons');

      grammarBtn.classList.toggle('active', mode === 'grammar');
      wildBtn.classList.toggle('active', mode === 'wild');
      wildBtn.classList.toggle('wild-active', mode === 'wild');

      const presetsSection = document.querySelector('.presets');

      if (mode === 'grammar') {
        description.textContent = 'Specify exact parts of speech';
        wildBuffaloBtn.style.display = '';
        bisonBtn.style.display = 'none';
        buttonsContainer.classList.remove('wild-mode');
        presetsSection.style.display = '';
      } else {
        description.textContent = 'Explore all possible parses';
        wildBuffaloBtn.style.display = 'none';
        bisonBtn.style.display = '';
        buttonsContainer.classList.add('wild-mode');
        presetsSection.style.display = 'none';
      }

      // Clear sentence when switching modes
      if (mode === 'wild') {
        // Wild mode starts with a single buffalo
        words = [{ word: 'buffalo', pos: 'WILD' }];
      } else {
        // Grammar mode starts with A-N-V pattern
        words = [
          { word: 'buffalo', pos: 'PN' },
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'V' },
        ];
      }

      // Re-render sentence to update styling
      renderSentence();
      updateWildcardButton();
      // Re-parse with new mode
      if (words.length > 0) {
        parseSentence();
      }
    };

    function hasWildcard() {
      return words.some(w => w.pos === 'WILD');
    }

    function getWildcardPosition() {
      // In wild mode, no specific wildcard position (all are wild)
      if (currentMode === 'wild') return undefined;
      const index = words.findIndex(w => w.pos === 'WILD');
      return index >= 0 ? index + 1 : undefined; // 1-indexed
    }

    function updateWildcardButton() {
      const btn = document.getElementById('wild-btn');
      if (currentMode === 'wild') {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
        btn.disabled = hasWildcard();
        btn.title = hasWildcard() ? 'Only one Golden Buffalo allowed per sentence' : 'Add wildcard (matches any POS)';
      }
    }

    let pendingWord = null;
    const WILD_MODE_WARNING_THRESHOLD = 5;

    window.addWord = function(pos) {
      if (currentMode === 'grammar' && pos === 'WILD' && hasWildcard()) return;

      // Check if we need to warn about slow computation in wild mode
      if (currentMode === 'wild' && words.length >= WILD_MODE_WARNING_THRESHOLD) {
        pendingWord = pos;
        const newCount = words.length + 1;
        document.getElementById('confirm-message').textContent =
          `Adding buffalo #${newCount} in Wild Mode requires computing ${Math.pow(3, newCount).toLocaleString()} possible combinations. This may take a while. Continue?`;
        document.getElementById('confirm-dialog').classList.add('active');
        return;
      }

      doAddWord(pos);
    };

    function doAddWord(pos) {
      words.push({ word: 'buffalo', pos });
      renderSentence();
      updateWildcardButton();
      parseSentence();
    }

    window.cancelAddWord = function() {
      pendingWord = null;
      document.getElementById('confirm-dialog').classList.remove('active');
    };

    window.proceedAddWord = function() {
      document.getElementById('confirm-dialog').classList.remove('active');
      if (pendingWord !== null) {
        doAddWord(pendingWord);
        pendingWord = null;
      }
    };

    window.clearSentence = function() {
      words = [];
      renderSentence();
      updateWildcardButton();
      showEmptyState(true);
    };

    window.loadPreset = function(count) {
      // Valid Buffalo sentence patterns (verified against grammar):
      // These patterns are confirmed to produce valid parses
      const presets = {
        3: [
          // "Bison from Buffalo intimidate" - S → NP(PN N) VP(V)
          { word: 'buffalo', pos: 'PN' },
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'V' },
        ],
        4: [
          // "Bison that bison from Buffalo intimidate" - S → NP with relative clause
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'PN' },
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'V' },
        ],
        5: [
          // "Bison that bison from Buffalo intimidate intimidate"
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'PN' },
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'V' },
          { word: 'buffalo', pos: 'V' },
        ],
        8: [
          // Closest to famous sentence structure with valid parse
          // "Bison that bison from Buffalo intimidate intimidate bison from Buffalo"
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'PN' },
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'V' },
          { word: 'buffalo', pos: 'PN' },
          { word: 'buffalo', pos: 'N' },
          { word: 'buffalo', pos: 'V' },
          { word: 'buffalo', pos: 'V' },
        ],
      };
      words = presets[count] || [];
      renderSentence();
      updateWildcardButton();
      parseSentence();
    };

    let draggedIndex = null;
    let draggedButtonPos = null;

    // Handle button drag events
    document.querySelectorAll('.buffalo-btn[data-pos]').forEach(btn => {
      btn.addEventListener('dragstart', handleButtonDragStart);
      btn.addEventListener('dragend', handleButtonDragEnd);
    });

    function handleButtonDragStart(e) {
      const pos = e.target.dataset.pos;
      if (pos === 'WILD' && hasWildcard()) {
        e.preventDefault();
        return;
      }
      draggedButtonPos = pos;
      e.dataTransfer.effectAllowed = 'copy';
      e.dataTransfer.setData('application/x-pos', pos);
      e.target.style.opacity = '0.5';
    }

    function handleButtonDragEnd(e) {
      e.target.style.opacity = '1';
      draggedButtonPos = null;
      removeDragIndicators();
    }

    // Handle drops on sentence container
    const sentenceContainer = document.getElementById('sentence');

    sentenceContainer.addEventListener('dragover', handleSentenceDragOver);
    sentenceContainer.addEventListener('dragenter', handleSentenceDragEnter);
    sentenceContainer.addEventListener('dragleave', handleSentenceDragLeave);
    sentenceContainer.addEventListener('drop', handleSentenceDrop);

    function handleSentenceDragOver(e) {
      e.preventDefault();
      if (draggedButtonPos) {
        e.dataTransfer.dropEffect = 'copy';
        updateDropIndicator(e);
      }
    }

    function handleSentenceDragEnter(e) {
      e.preventDefault();
      if (draggedButtonPos) {
        sentenceContainer.classList.add('drop-active');
      }
    }

    function handleSentenceDragLeave(e) {
      // Only remove if actually leaving the container
      if (!sentenceContainer.contains(e.relatedTarget)) {
        sentenceContainer.classList.remove('drop-active');
        removeDragIndicators();
      }
    }

    function handleSentenceDrop(e) {
      e.preventDefault();
      sentenceContainer.classList.remove('drop-active');

      // Mark that a word was dropped inside (for drag-off detection)
      if (draggedIndex !== null) {
        wordDroppedInside = true;
      }

      const pos = e.dataTransfer.getData('application/x-pos');
      if (pos) {
        // Insert at calculated position
        const insertIndex = getInsertIndex(e);
        if (pos === 'WILD' && hasWildcard()) return;

        words.splice(insertIndex, 0, { word: 'buffalo', pos });
        renderSentence();
        updateWildcardButton();
        parseSentence();
      }

      removeDragIndicators();
    }

    function getInsertIndex(e) {
      const wordElements = sentenceContainer.querySelectorAll('.word');
      if (wordElements.length === 0) return 0;

      const containerRect = sentenceContainer.getBoundingClientRect();
      const x = e.clientX;

      for (let i = 0; i < wordElements.length; i++) {
        const rect = wordElements[i].getBoundingClientRect();
        const midpoint = rect.left + rect.width / 2;
        if (x < midpoint) {
          return i;
        }
      }
      return wordElements.length;
    }

    function updateDropIndicator(e) {
      removeDragIndicators();

      const wordElements = sentenceContainer.querySelectorAll('.word');
      if (wordElements.length === 0) return;

      const insertIndex = getInsertIndex(e);
      const indicator = document.createElement('span');
      indicator.className = 'drop-indicator';

      if (insertIndex >= wordElements.length) {
        wordElements[wordElements.length - 1].after(indicator);
      } else {
        wordElements[insertIndex].before(indicator);
      }
    }

    function removeDragIndicators() {
      sentenceContainer.querySelectorAll('.drop-indicator').forEach(el => el.remove());
    }

    function renderSentence() {
      const container = document.getElementById('sentence');
      if (words.length === 0) {
        container.innerHTML = '<span style="color: #999;">Click or drag buttons to add words...</span>';
        return;
      }

      container.innerHTML = words.map((w, i) => {
        let label, cls;

        if (currentMode === 'wild') {
          // In wild mode, all words look the same (neutral buffalo)
          label = 'buffalo';
          cls = 'word-wild-mode';
        } else if (w.pos === 'WILD') {
          label = 'Buffalo? ✨';
          cls = 'word-wild';
        } else {
          label = w.pos === 'PN' ? 'Buffalo' : 'buffalo';
          const posClasses = { PN: 'word-pn', N: 'word-n', V: 'word-v' };
          cls = posClasses[w.pos] || 'word-n';
        }
        const position = i + 1;
        return `<span class="word ${cls}"
                      draggable="true"
                      data-index="${i}"
                      title="Drag to reorder or drag off to remove"><span class="word-position">${position}</span>${label}<span class="word-close" data-index="${i}">×</span></span>`;
      }).join('');

      // Add drag event listeners
      container.querySelectorAll('.word').forEach(el => {
        el.addEventListener('dragstart', handleDragStart);
        el.addEventListener('dragend', handleDragEnd);
        el.addEventListener('dragover', handleDragOver);
        el.addEventListener('dragenter', handleDragEnter);
        el.addEventListener('dragleave', handleDragLeave);
        el.addEventListener('drop', handleDrop);
      });

      // Add close button click handlers
      container.querySelectorAll('.word-close').forEach(el => {
        el.addEventListener('click', handleCloseClick);
      });
    }

    function handleCloseClick(e) {
      e.stopPropagation();
      const index = parseInt(e.target.dataset.index);
      const wordEl = e.target.closest('.word');
      const rect = wordEl.getBoundingClientRect();

      // Add poof animation
      wordEl.classList.add('poof');
      showPoofEmoji(rect.left + rect.width / 2, rect.top + rect.height / 2);
      setTimeout(() => {
        removeWord(index);
      }, 250);
    }

    function showPoofEmoji(x, y) {
      const emoji = document.createElement('div');
      emoji.className = 'poof-emoji';
      emoji.textContent = '💨';
      emoji.style.left = x + 'px';
      emoji.style.top = y + 'px';
      document.body.appendChild(emoji);
      setTimeout(() => emoji.remove(), 500);
    }

    let wordDroppedInside = false;
    let lastDragX = 0;
    let lastDragY = 0;

    // Track mouse position during drag (dragend coordinates are unreliable)
    document.addEventListener('dragover', (e) => {
      lastDragX = e.clientX;
      lastDragY = e.clientY;
    });

    function handleDragStart(e) {
      draggedIndex = parseInt(e.target.dataset.index);
      wordDroppedInside = false;
      lastDragX = e.clientX;
      lastDragY = e.clientY;
      e.target.classList.add('dragging');
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', draggedIndex);
    }

    function handleDragEnd(e) {
      e.target.classList.remove('dragging');
      document.querySelectorAll('.word').forEach(el => {
        el.classList.remove('drag-over', 'drag-over-left');
      });

      // If word was dragged outside sentence container, remove with poof
      if (!wordDroppedInside && draggedIndex !== null) {
        const wordEl = e.target;
        wordEl.classList.add('poof');
        showPoofEmoji(lastDragX, lastDragY);
        const indexToRemove = draggedIndex;
        setTimeout(() => {
          removeWord(indexToRemove);
        }, 250);
      }

      draggedIndex = null;
    }

    function handleDragOver(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
    }

    function handleDragEnter(e) {
      e.preventDefault();
      const targetIndex = parseInt(e.target.dataset.index);
      if (targetIndex !== draggedIndex) {
        e.target.classList.add(targetIndex > draggedIndex ? 'drag-over' : 'drag-over-left');
      }
    }

    function handleDragLeave(e) {
      e.target.classList.remove('drag-over', 'drag-over-left');
    }

    function handleDrop(e) {
      e.preventDefault();
      wordDroppedInside = true;
      const targetIndex = parseInt(e.target.dataset.index);

      if (draggedIndex !== null && targetIndex !== draggedIndex) {
        // Remove from old position and insert at new position
        const [moved] = words.splice(draggedIndex, 1);
        words.splice(targetIndex, 0, moved);
        renderSentence();
        updateWildcardButton();
        parseSentence();
      }
    }

    window.removeWord = function(index) {
      words.splice(index, 1);
      renderSentence();
      updateWildcardButton();
      parseSentence();
    };

    function showLoading(show, wordCount = 0) {
      const overlay = document.getElementById('loading-overlay');
      const subtext = document.getElementById('loading-subtext');
      if (show) {
        const combinations = Math.pow(3, wordCount);
        subtext.textContent = `Computing ${combinations.toLocaleString()} possible combinations...`;
        overlay.classList.add('active');
      } else {
        overlay.classList.remove('active');
      }
    }

    function showEmptyState(show) {
      document.getElementById('empty-state').style.display = show ? '' : 'none';
      document.getElementById('parse-count').style.display = show ? 'none' : '';
      document.querySelector('.parse-navigation').style.display = show ? 'none' : 'flex';
      document.querySelector('.parse-content').style.display = show ? 'none' : '';
      document.querySelector('.legend').style.display = show ? 'none' : '';
    }

    window.parseSentence = function() {
      if (words.length === 0) {
        showEmptyState(true);
        return;
      }

      // Count wildcards to determine if we need loading indicator
      const wildcardCount = currentMode === 'wild' ? words.length : words.filter(w => w.pos === 'WILD').length;
      const needsLoading = wildcardCount >= 4;

      if (needsLoading) {
        showLoading(true, currentMode === 'wild' ? words.length : wildcardCount);
        // Use setTimeout to allow the loading overlay to render
        setTimeout(() => doParse(), 50);
      } else {
        doParse();
      }
    };

    function doParse() {
      showEmptyState(false);
      const startTime = performance.now();

      // Expand wildcards into all possible POS combinations
      const allTrees = [];
      const posOptions = ['PN', 'N', 'V'];

      // Get terminal POS tags from a parse tree in order
      function getTreePOS(node) {
        if (node.children.length === 0) {
          return [node.symbol];
        }
        return node.children.flatMap(c => getTreePOS(c));
      }

      // Check if a tree's POS sequence matches the user's constraints
      function treeMatchesConstraints(tree, constraints) {
        const treePOS = getTreePOS(tree.root);
        if (treePOS.length !== constraints.length) return false;
        return constraints.every((c, i) => c === 'WILD' || c === treePOS[i]);
      }

      function expandWildcards(wordList, index, current) {
        if (index >= wordList.length) {
          // Parse this combination
          const sentence = current.map(w => w.pos === 'PN' ? 'Buffalo' : 'buffalo');
          const result = parser.parse(sentence);

          // In grammar mode, filter trees to match user's POS constraints
          // In wild mode, accept all valid parses
          if (currentMode === 'grammar') {
            const constraints = current.map(w => w.pos);
            const matchingTrees = result.trees.filter(t => treeMatchesConstraints(t, constraints));
            allTrees.push(...matchingTrees);
          } else {
            allTrees.push(...result.trees);
          }
          return;
        }

        // In wild mode, treat every word as a wildcard
        const isWild = currentMode === 'wild' || wordList[index].pos === 'WILD';

        if (isWild) {
          // Try all POS options for wildcard
          for (const pos of posOptions) {
            expandWildcards(wordList, index + 1, [...current, { word: 'buffalo', pos }]);
          }
        } else {
          expandWildcards(wordList, index + 1, [...current, wordList[index]]);
        }
      }

      expandWildcards(words, 0, []);

      // Deduplicate trees (parser already dedupes, but wildcard expansion may create more dupes)
      const seen = new Set();
      parseTrees = allTrees.filter(tree => {
        const key = serializeTree(tree.root);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      currentParse = 0;

      const resultsEl = document.getElementById('results');
      resultsEl.style.display = 'block';

      // Always clear previous visualization and interpretation first
      document.getElementById('visualization').innerHTML = '';
      document.getElementById('interpretation').innerHTML = '';

      const elapsed = ((performance.now() - startTime) / 1000).toFixed(2);

      if (parseTrees.length === 0) {
        document.getElementById('parse-count').textContent = '⚠️ No valid parses found';
        document.getElementById('visualization').innerHTML = '<div class="no-parses">This combination doesn\'t form a valid sentence.<br>Try a different arrangement!</div>';
        document.querySelector('.parse-navigation').style.display = 'none';
      } else {
        const timeInfo = elapsed > 0.5 ? ` (${elapsed}s)` : '';
        document.getElementById('parse-count').textContent = `Found ${parseTrees.length} valid parse${parseTrees.length > 1 ? 's' : ''}${timeInfo}`;
        document.querySelector('.parse-navigation').style.display = 'flex';
        showParse(0);
      }

      showLoading(false);
    }

    function serializeTree(node) {
      if (node.children.length === 0) {
        return `(${node.symbol} "${node.word ?? ''}")`;
      }
      const children = node.children.map(c => serializeTree(c)).join(' ');
      return `(${node.symbol} ${children})`;
    }

    window.showParse = function(index) {
      if (index < 0 || index >= parseTrees.length) return;

      currentParse = index;
      document.getElementById('parse-index').textContent = `${index + 1} / ${parseTrees.length}`;
      document.getElementById('prev-btn').disabled = index === 0;
      document.getElementById('next-btn').disabled = index === parseTrees.length - 1;

      rerender();
    };

    window.rerender = function() {
      const style = document.getElementById('style-select').value;
      const wildcardPosition = getWildcardPosition();
      const tree = parseTrees[currentParse];
      const svg = renderTreeToSVG(tree, { style, wildcardPosition });
      document.getElementById('visualization').innerHTML = svg;

      // Show interpretation
      const interpretation = interpretTreeHTML(tree);
      document.getElementById('interpretation').innerHTML = `
        <div class="interpretation-label">Meaning</div>
        ${interpretation}
      `;
    };

    // Initialize with A-N-V pattern
    words = [
      { word: 'buffalo', pos: 'PN' },
      { word: 'buffalo', pos: 'N' },
      { word: 'buffalo', pos: 'V' },
    ];
    renderSentence();
    updateWildcardButton();
    parseSentence();
  